import { useTranslation } from '../presentation/common/useTranslation.js';
import { RotateCcw } from 'lucide-react';

import { getPresentation } from '../presentation/runtime';
import '../styles/world.css';
import './ErrorFallback.css';

export default function ErrorFallback({ error }) {
  const { t } = useTranslation();

  return (
    <main className="system-error-shell">
      <section className="world-error-page system-error-page" role="alert">
        <div className="world-error-glow" aria-hidden="true" />
        <div className="world-error-orbit" aria-hidden="true">
          <img src={getPresentation().errorImage} alt="" className="world-error-pixel-art" />
          <span className="world-error-sparkle">✧</span>
        </div>
        <span className="world-eyebrow">✦ GOODVALE · {t('error.title')} ✦</span>
        <h1>{t('error.title')}</h1>
        <p>{t('error.desc')}</p>
        <div className="world-divider" aria-hidden="true">◇</div>
        <div className="world-error-actions">
          <button type="button" className="world-button world-button-primary" onClick={() => window.location.reload()}>
            <RotateCcw size={18} aria-hidden="true" />
            {t('error.reload')}
          </button>
        </div>
        {import.meta.env.DEV && error && (
          <pre className="system-error-details">{String(error)}</pre>
        )}
      </section>
    </main>
  );
}
